import './CompoHistoria.css'

export default function CompoHistoria() {

    return (

        <section className='historiaEmpresa'>
            <article>
                <h1>História</h1>
            </article>

            <article className='pagHistoria'>
                <p>Com mais de 44 anos de experiência no mercado, somos uma distribuidora de
                    alimentos especializada no atendimento de pizzarias, restaurantes, padarias, mercados
                    e açougues. Fundada em 1980, nossa empresa está localizada em São Paulo e atua
                    predominantemente no comércio atacadista de produtos alimentícios,
                    conforme a classificação da Receita Federal (46.39-7-01).
                </p>
                <p>
                    Desde a nossa fundação, temos nos dedicado a fornecer serviços de alta qualidade,
                    sempre com o compromisso de atender às necessidades de nossos clientes de forma
                    eficaz e satisfatória. Contamos com uma equipe de profissionais altamente
                    qualificados, que compartilham o nosso compromisso com a excelência e a eficiência
                    no serviço.
                </p>
                <p>
                    Nosso objetivo é proporcionar um atendimento de excelência em toda a região de São
                    Paulo, mantendo parcerias sólidas com grandes marcas do setor, como Aurora,
                    BemBrasil, Friboi e Perdigão e vários outros parceiros. Acreditamos que nossa
                    experiência, aliada ao nosso foco em qualidade e profissionalismo, faz de nós um
                    parceiro confiável e indispensável para o sucesso dos nossos clientes.
                </p>
                <p>
                Estamos prontos para atender suas necessidades e contribuir para o crescimento do
                seu negócio com a mesma dedicação e compromisso que nos trouxeram até aqui.
                </p>

            </article>


        </section>
    )
}